<template>
  <div id="intro-1" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Welcome to Visceral's <br>New Vendor Consignment</h3>
      </div>

      <div class="intro-box__content">
        <p>Our app has gotten a whole lot better.</p>

        <ul>
          <li>New Dashboard</li>
          <li>One Click Payouts</li>
          <li>Redesigned Vendor Details</li>
<!--          <li>Data Export</li>-->
          <li>New Payouts View</li>
          <li>Better Performance</li>
          <li>New Help <i class="fa-question-circle fas"></i> Section</li>
        </ul>

        <p>Please accept our new terms & conditions & Privacy Policy. Also,
          please run a data re-sync in the app settings if any commissions are
          not accurate. If you still notice any issues, please reach out through
          out chat service so we can remedy the calculations.</p>
      </div>

      <div class="intro-box__wrapper--fixed">
        <div class="form-field text-left">
          <div class="grid-x">
            <div class="cell shrink">
              <div :class="['checkbox-choice', termsAccepted ? 'active' : '']"
                   @click="agreeToTerms">
                <input id="agree-terms" type="checkbox" name="agree-terms"
                       :checked="termsAccepted">
              </div>
            </div>

            <div class="cell auto">
              <label class="checkbox-choice__label" for="agree-terms">I agree to the Visceral Apps
                <router-link to="/">Terms of Service</router-link> and
                <router-link to="/">Privacy Policy</router-link>.
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <button :class="['button--wide', !termsAccepted ? 'disabled': '']" @click="changeStep()">
        Get Started
      </button>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [client],
  data: function () {
    return {
      termsAccepted: false
    }
  },
  methods: {
    agreeToTerms () {
      this.termsAccepted = !this.termsAccepted
    },
    changeStep () {
      if (this.termsAccepted) {
        this.request('put', '/shopify/shops/' + this.$store.state.shop.id + '/retrieve-update/', {
          agree_to_terms: this.termsAccepted
        }).then(response => {
          this.$emit('finished')
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step1Alt.vue